import { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { Manager, Popper, Reference } from 'react-popper'
import classNames from 'classnames'
import { Fade } from 'components/misc/Fade'
import PaperLink from 'components/report/PaperLink'
import styles from './styles/CiteRef.css'
import tooltipStyles from 'components/misc/styles/Tooltip.css'

export const CiteRef = ({ dois, reportTarget, linkTarget = false, reference }) => {
  const [show, setShow] = useState(false)
  const [initialRender, setInitialRender] = useState(true)

  const handleClick = _ => setShow(!show)

  const isTarget = dois.includes(reportTarget)

  useEffect(() => {
    setInitialRender(false)
  }, [])

  if (dois.length === 0) {
    return reference || ''
  }

  if (initialRender || dois.length === 1) {
    return (
      <PaperLink doi={dois[0]} isTarget={isTarget} linkTarget={linkTarget}>
        {reference || '[ref]'}
      </PaperLink>
    )
  }

  return (
    <Manager>
      <Reference>
        {({ ref }) => (
          <span ref={ref}>
            <PaperLink
              isTarget={isTarget}
              onClick={handleClick}
            >
              {reference || '[refs]'}
            </PaperLink>
          </span>
        )}
      </Reference>
      {
        createPortal(
          (
            <Fade className={styles.citeTooltip} show={show}>
              <Popper placement='top' strategy='fixed'>
                {({ ref, style, placement, arrowProps }) => (
                  <div
                    className={classNames(tooltipStyles.popperBase, tooltipStyles.popper)}
                    ref={ref}
                    style={style}
                    data-placement={placement}
                  >
                    {dois.map((doi, index) => (
                      <div key={doi}>
                        {index + 1}.&nbsp;
                        <PaperLink doi={doi} isTarget={doi === reportTarget}>
                          {doi}
                        </PaperLink>
                      </div>
                    ))}
                    <div
                      className={classNames(tooltipStyles.arrow, tooltipStyles.arrowBlack)}
                      ref={arrowProps.ref}
                      style={arrowProps.style}
                    />
                  </div>
                )}
              </Popper>
            </Fade>
          ),
          document.querySelector('#scite-tooltips')
        )
      }
    </Manager>
  )
}

CiteRef.propTypes = {
  dois: PropTypes.arrayOf(PropTypes.string).isRequired,
  reportTarget: PropTypes.string,
  reference: PropTypes.node,
  linkTarget: PropTypes.bool
}

export default CiteRef
